import { qsa, contains } from "@fluorescent/dom";
import {
  FadeUpReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  group: ".inline-features__item",
  revealItem: ".animation-fade-up-split-reveal, .animation-fade-up-reveal",
};

export default node => {
  let observer = null;
  // Each group has a staggered animation delay so we get each groups container
  const revealGroup = qsa(selectors.group, node);

  const reveals = [];

  if (shouldAnimate(node)) {
    // Initialize animations and intersection observer
    // Loop through each reveal group and initialize the reveals for each item in the group
    revealGroup.forEach(item => {
      const groupReveals = [];
      qsa(selectors.revealItem, item).forEach(revealItem => {
        // check which type of reveal needs to be initialized
        if (contains(revealItem, "animation-fade-up-split-reveal")) {
          groupReveals.push(new FadeUpSplitReveal(revealItem));
        } else if (contains(revealItem, "animation-fade-up-reveal")) {
          groupReveals.push(new FadeUpReveal(revealItem));
        }
      });
      reveals.push(groupReveals);
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let revealGroupDelay = 0;
    reveals.forEach((revealGroup, i) => {
      revealGroupDelay = window.theme.animation.delay * i;

      revealGroup.forEach(revealItem => {
        revealItem.play(revealGroupDelay);

        revealGroupDelay += window.theme.animation.delayExtraShort;
      });
    });
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
